module.exports = __webpack_public_path__ + "static/img/17913991-53ca-46b7-ad36-89e0629a34dc.5e87250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17913991-53ca-46b7-ad36-89e0629a34dc.png
// module id = Ck1g
// module chunks = 1